// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__y2S3x","log":"ModalInventoryLogs_log__Z8aEC","date":"ModalInventoryLogs_date__3f-iQ","userName":"ModalInventoryLogs_userName__1Wliz"};